import { render, staticRenderFns } from "./body-cell.vue?vue&type=template&id=30cecd36&"
import script from "./body-cell.vue?vue&type=script&lang=js&"
export * from "./body-cell.vue?vue&type=script&lang=js&"
import style0 from "./body-cell.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports